import { createAction, props } from '@ngrx/store';

import { Department } from '@apps/its2/domain/models/department';

export const RootDepartmentsRequested = createAction(
    '[ROOT-DEPARTMENTS] Departments Requested'
);

export const RootDepartmentsSucceeded = createAction(
    '[ROOT-DEPARTMENTS] Departments Succeeded',
    props<{ departments: Department[] }>()
);

export const RootDepartmentsFailed = createAction(
    '[ROOT-DEPARTMENTS] Departments Failed'
);
